export const selectApplicationsState = (state) => state.applications;

export const selectApplications = (state) =>
  state.applications.applications;

export const selectApplication = (state) =>
  state.applications.application;

export const selectApplicationsCount = (state) =>
  state.applications.applicationsCount;

export const selectApplicationsOrderBy = (state) =>
  state.applications.applicationsOrderBy;

export const selectApplicationsFilter = (state) =>
  state.applications.applicationsFilter;

export const selectApplicationsPagination = (state) =>
  state.applications.applicationsPagination;

export const selectAppointments = (state) =>
  state.applications.appointments;

export const selectAppointmentsCount = (state) =>
  state.applications.appointmentsCount;

export const selectComments = (state) =>
  state.applications.comments;

export const selectCommentsCount = (state) =>
  state.applications.commentsCount;
